import React from 'react';
import { XIcon } from 'lucide-react';
import { PAIN_POINTS } from './salesData';
export function PainSection() {
  return <section className="bg-cream py-12 sm:py-16" data-id="element-157" data-mp="38wlueu6m0ui9">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-158" data-mp="2uy5mizx0gxyj">
        <h2 className="font-display text-2xl font-black leading-tight text-ink sm:text-4xl" data-id="element-159" data-mp="2uxm29cjw1xhc">
          Si atendés pacientes todo el día, Instagram no debería convertirse en otro trabajo.
        </h2>

        <ul className="mx-auto mt-7 grid gap-2.5 text-left sm:grid-cols-2" data-id="element-160" data-mp="2l6reg3qzupts">
          {PAIN_POINTS.map(p => <li key={p} className="flex items-start gap-2.5 rounded-xl border border-rose/10 bg-white p-3.5 shadow-sm" data-id="element-161" data-mp="2q15isvnmw7al">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-rose/10" data-id="element-162" data-mp="2gaat1hb6ipke">
                <XIcon className="h-3.5 w-3.5 text-rose-deep" aria-hidden data-id="element-163" data-mp="22a03chllvh0t" />
              </span>
              <span className="text-sm leading-snug text-ink/75" data-id="element-164" data-mp="2781kgwzh169n">{p}</span>
            </li>)}
        </ul>

        <p className="mx-auto mt-7 max-w-2xl font-display text-lg font-bold leading-snug text-rose-deep sm:text-2xl" data-id="element-165" data-mp="3rl7ns6pcqbzp">
          El problema no es que necesites trabajar más en Instagram. Necesitás un sistema.
        </p>
      </div>
    </section>;
}